import React from 'react';
import {BrowserRouter} from "react-router-dom";
import {IsMobileProvider} from "./providers/IsMobileProvider";
import {TimezoneProvider} from "./contexts/TimezoneContext";
import {PendingTransactionProvider} from "./contexts/PendingTransactionContext";
import AppRoutes from "./Routes";
import {ToastContainer} from "react-toastify";

function App() {
  return (
    <IsMobileProvider>
      <TimezoneProvider>
        <PendingTransactionProvider>
          <BrowserRouter>
            <AppRoutes />
            <ToastContainer />
          </BrowserRouter>
        </PendingTransactionProvider>
      </TimezoneProvider>
    </IsMobileProvider>
  );
}

export default App;
